const SET_ADMIN_TASK_GRID_VALUES = 'SET_ADMIN_TASK_GRID_VALUES'
const SET_INITIAL_TASK_DETAIL = 'SET_INITIAL_TASK_DETAIL'
const SET_ATTACHMENTS_LIST = 'SET_ATTACHMENTS_LIST'
const SET_LINKED_ATTACHMENTS = 'SET_LINKED_ATTACHMENTS'
const GET_FLEET_PROCESSING_ITEM_STATUS_LIST = 'GET_FLEET_PROCESSING_ITEM_STATUS_LIST'
const SET_FLEET_PROCESSING_ITEM_STATUS_LIST = 'SET_FLEET_PROCESSING_ITEM_STATUS_LIST'
const SET_RECEVING_COSTCENTER_OPTION = 'SET_RECEVING_COSTCENTER_OPTION'
const SET_UPDATE_REASON_CODE_RESPONSE = "SET_UPDATE_REASON_CODE_RESPONSE"
const GET_ORDER_HEADER_DETAILS = "GET_ORDER_HEADER_DETAILS";
const SET_ORDER_HEADER_DETAILS = "SET_ORDER_HEADER_DETAILS";

/// Get API endpoints
const GET_FLEET_ITEM_HEADER_DETAILS = "GET_FLEET_ITEM_HEADER_DETAILS";
const SET_FLEET_ITEM_HEADER_DETAILS = "SET_FLEET_ITEM_HEADER_DETAILS";
const GET_FLEET_ITEM_DETAILS = "GET_FLEET_ITEM_DETAILS";
const SET_FLEET_ITEM_DETAILS = "SET_FLEET_ITEM_DETAILS";
const GET_FLEET_ITEM_PURCHASE_DETAILS = "GET_FLEET_ITEM_PURCHASE_DETAILS";
const SET_FLEET_ITEM_PURCHASE_DETAILS = "SET_FLEET_ITEM_PURCHASE_DETAILS";
const GET_FLEET_ITEM_PURCHASE_ORDER = "GET_FLEET_ITEM_PURCHASE_ORDER";
const SET_FLEET_ITEM_PURCHASE_ORDER = "SET_FLEET_ITEM_PURCHASE_ORDER";
const GET_FLEET_ITEM_VENDOR_DETAILS = "GET_FLEET_ITEM_VENDOR_DETAILS";
const SET_FLEET_ITEM_VENDOR_DETAILS = "SET_FLEET_ITEM_VENDOR_DETAILS";
const GET_FLEET_ITEM_TASK_DETAILS = "GET_FLEET_ITEM_TASK_DETAILS";
const SET_FLEET_ITEM_TASK_DETAILS = "SET_FLEET_ITEM_TASK_DETAILS";

///Save API endpoints
const GET_FLEET_ITEM_PURCHASE_DETAILS_SAVE = "GET_FLEET_ITEM_PURCHASE_DETAILS_SAVE";
const SET_FLEET_ITEM_PURCHASE_DETAILS_SAVE = "SET_FLEET_ITEM_PURCHASE_DETAILS_SAVE";
const GET_FLEET_ITEM_PURCHASE_ORDER_SAVE = "GET_FLEET_ITEM_PURCHASE_ORDER_SAVE";
const SET_FLEET_ITEM_PURCHASE_ORDER_SAVE = "SET_FLEET_ITEM_PURCHASE_ORDER_SAVE";
const GET_FLEET_ITEM_VENDOR_DETAILS_SAVE = "GET_FLEET_ITEM_VENDOR_DETAILS_SAVE";
const SET_FLEET_ITEM_VENDOR_DETAILS_SAVE = "SET_FLEET_ITEM_VENDOR_DETAILS_SAVE";
const SAVE_COMMENT = "SAVE_COMMENT"
const SET_COMMENT_SAVED = "SET_COMMENT_SAVED"

const SAVE_ITEM_DETAILS = "SAVE_ITEM_DETAILS"
const SET_IS_ITEM_DETAILS_SAVED = "SET_IS_ITEM_DETAILS_SAVED"

const SAVE_ITEM_ATTACHMENTS_LINKED = "SAVE_ITEM_ATTACHMENTS_LINKED"
const SET_ITEM_ATTACHMENTS_LINKED_SAVED = "SET_ITEM_ATTACHMENTS_LINKED_SAVED"

const SAVE_MULTIPLE_PURCHASE_DETAILS = "SAVE_MULTIPLE_PURCHASE_DETAILS"
const IS_MULTIPLE_POD_SAVED = "IS_MULTIPLE_POD_SAVED"

const SAVE_MULTIPLE_DEALER_VENDOR_DETAILS = "SAVE_MULTIPLE_DEALER_VENDOR_DETAILS"
const IS_MULTIPLE_DEALER_VENDOR_SAVED = "IS_MULTIPLE_DEALER_VENDOR_SAVED"

const SAVE_MULTIPLE_PO_DETAILS = "SAVE_MULTIPLE_PO_DETAILS"
const IS_MULTIPLE_PO_DETAILS_SAVED = "IS_MULTIPLE_PO_DETAILS_SAVED"

const SAVE_CONSOLIDATED_PO_FLAG = "SAVE_CONSOLIDATED_PO_FLAG"
const IS_CONSOLIDATED_FLAG_SAVED = "IS_CONSOLIDATED_FLAG_SAVED"

const SAVE_ORDER_ATTACHMENTS = "SAVE_ORDER_ATTACHMENTS"
const IS_ORDER_ATTACHMENTS_SAVED = "IS_ORDER_ATTACHMENTS_SAVED"

const SAVE_ASSIGNED_TO_FOR_ALL_ITEM = 'SAVE_ASSIGNED_TO_FOR_ALL_ITEM'
const SET_ASSIGNED_TO_FOR_ALL_ITEM = 'SET_ASSIGNED_TO_FOR_ALL_ITEM'

const SET_OPEN_ACCORDION_LIST = 'SET_OPEN_ACCORDION_LIST'

const VALIDATE_VIN_DUPLICATE = 'VALIDATE_VIN_DUPLICATE'
const SET_VIN_VALIDATION_RESULT = 'SET_VIN_VALIDATION_RESULT'

const SAVE_CATALOG_OVERRIDE = 'SAVE_CATALOG_OVERRIDE'
const SET_CATALOG_OVERRIDE_SAVED = 'SET_CATALOG_OVERRIDE_SAVED'

export {
    SET_ADMIN_TASK_GRID_VALUES,
    SET_INITIAL_TASK_DETAIL,
    SET_ATTACHMENTS_LIST,
    SET_LINKED_ATTACHMENTS,
    GET_FLEET_PROCESSING_ITEM_STATUS_LIST,
    SET_FLEET_PROCESSING_ITEM_STATUS_LIST,
    SET_RECEVING_COSTCENTER_OPTION,
    SET_UPDATE_REASON_CODE_RESPONSE,
    SET_ORDER_HEADER_DETAILS,
    GET_ORDER_HEADER_DETAILS,
    GET_FLEET_ITEM_HEADER_DETAILS,
    SET_FLEET_ITEM_HEADER_DETAILS,
    GET_FLEET_ITEM_DETAILS,
    SET_FLEET_ITEM_DETAILS,
    GET_FLEET_ITEM_PURCHASE_DETAILS,
    GET_FLEET_ITEM_PURCHASE_ORDER,
    SET_FLEET_ITEM_PURCHASE_DETAILS,
    SET_FLEET_ITEM_PURCHASE_ORDER,
    GET_FLEET_ITEM_VENDOR_DETAILS,
    SET_FLEET_ITEM_VENDOR_DETAILS,
    GET_FLEET_ITEM_TASK_DETAILS,
    SET_FLEET_ITEM_TASK_DETAILS,
    GET_FLEET_ITEM_PURCHASE_DETAILS_SAVE,
    SET_FLEET_ITEM_PURCHASE_DETAILS_SAVE,
    GET_FLEET_ITEM_PURCHASE_ORDER_SAVE,
    SET_FLEET_ITEM_PURCHASE_ORDER_SAVE,
    GET_FLEET_ITEM_VENDOR_DETAILS_SAVE,
    SET_FLEET_ITEM_VENDOR_DETAILS_SAVE,
    SAVE_COMMENT,
    SET_COMMENT_SAVED,
    SAVE_ITEM_DETAILS,
    SET_IS_ITEM_DETAILS_SAVED,
    SAVE_ITEM_ATTACHMENTS_LINKED,
    SET_ITEM_ATTACHMENTS_LINKED_SAVED,
    SAVE_MULTIPLE_PURCHASE_DETAILS,
    IS_MULTIPLE_POD_SAVED,
    SAVE_MULTIPLE_DEALER_VENDOR_DETAILS,
    IS_MULTIPLE_DEALER_VENDOR_SAVED,
    SAVE_MULTIPLE_PO_DETAILS,
    IS_MULTIPLE_PO_DETAILS_SAVED,
    SAVE_CONSOLIDATED_PO_FLAG,
    IS_CONSOLIDATED_FLAG_SAVED,
    SAVE_ORDER_ATTACHMENTS,
    IS_ORDER_ATTACHMENTS_SAVED,
    SAVE_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_OPEN_ACCORDION_LIST,
    VALIDATE_VIN_DUPLICATE,
    SET_VIN_VALIDATION_RESULT,
    SAVE_CATALOG_OVERRIDE,
    SET_CATALOG_OVERRIDE_SAVED
}